import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyleObj } from '../../../../@types';
import { scrollToTop } from '../../../../utils/scrollToTop';

const styles: StyleObj = {
  button: {
    width: '100%',
    color: 'neutral.100',
    borderRadius: 0.5,
    fontWeight: 400,
    backgroundColor: 'neutral.500',
  },
};

const BackToTopButton = () => {
  const { t } = useTranslation();

  return (
    <Button onClick={scrollToTop} sx={styles.button}>
      {t('backToTop')}
    </Button>
  );
};

export default BackToTopButton;
